module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"PrivacyPolicyText":"(EN) Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec elementum bibendum erat, et consectetur sapien fringilla tristique."},"hr":{"PrivacyPolicyText":"(HR) Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec elementum bibendum erat, et consectetur sapien fringilla tristique."}}')
  delete Component.options._Ctor
}
